import type { HTMLAttributes } from "react";
import { cn } from "@/shared/lib/utils";
import type { HeadingProps } from "@/shared/components/typography";
import { H2 } from "@/shared/components/typography";

interface BaseDataPageProps extends HTMLAttributes<HTMLDivElement> {}

export function BaseDataPage({ children, ...props }: BaseDataPageProps) {
  return <div {...props}>{children}</div>;
}

export function BaseDataPageHeader({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn("space-y-2", className)} {...props}>
      {children}
    </div>
  );
}

interface BaseDataPageTitleProps extends HeadingProps {}

export function BaseDataPageTitle({
  children,
  className,
  ...props
}: BaseDataPageTitleProps) {
  return (
    <H2 className={cn("flex w-full justify-between", className)} {...props}>
      {children}
    </H2>
  );
}

export function BaseDataPageDescription({
  children,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn("text-muted-foreground text-sm")} {...props}>
      {children}
    </div>
  );
}

export function BaseDataPageContent({
  children,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn("space-y-4 py-4", props.className)}>{children}</div>
  );
}
